/*
 *
 * Copyright (c) 2020 TenderHub LLC. All rights reserved
 *
 * This software is the confidential and proprietary information of
 * TenderHub LLC ("Confidential Information"). You shall not disclose
 * such Confidential Information.
 *
 */

import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { TokenParamGuard } from '@site-shared/core';
import { IMfeContainerData, MfeContainerComponent } from '@site-shared/mfe';
import { PublicLayoutComponent } from '@site-shared/public';
import { defaultFallbackContext, RegistrationActionResolver } from './helpers';

const routes: Routes = [
	{
		path: '',
		component: PublicLayoutComponent,
		children: [
			{
				path: '',
				redirectTo: 'agents',
				pathMatch: 'full',
			},
			{
				path: 'users',
				data: {
					segment: 'users',
					mfe: 'signon-agents/signon-public-register',
					loaderDelay: 500,
					fallbackContext: defaultFallbackContext,
					loader: 'loaders/whitelabel-redesign',
				},
				resolve: { action: RegistrationActionResolver },
				component: MfeContainerComponent,
				canActivate: [TokenParamGuard],
				runGuardsAndResolvers: 'always',
			},
			{
				path: 'employees',
				data: {
					segment: 'employees',
					mfe: 'signon-agents/signon-public-register',
					loaderDelay: 500,
					fallbackContext: defaultFallbackContext,
					loader: 'loaders/whitelabel-redesign',
				},
				resolve: { action: RegistrationActionResolver },
				component: MfeContainerComponent,
				canActivate: [TokenParamGuard],
				runGuardsAndResolvers: 'always',
			},
			{
				path: 'agents',
				data: { segment: 'agents' },
				loadChildren: () =>
					import('./containers/containers.module').then((x) => x.ContainersModule),
			},
			{
				path: 'clients',
				data: { segment: 'clients' },
				loadChildren: () =>
					import('./containers/containers.module').then((x) => x.ContainersModule),
			},
			{
				path: 'status',
				component: MfeContainerComponent,
				data: {
					mfe: 'notice',
					loader: 'loaders/whitelabel-redesign',
					loaderDelay: 500,
					fallbackContext: defaultFallbackContext,
				} as IMfeContainerData,
			},
			{
				path: '**',
				redirectTo: 'agents',
			},
		],
	},
];

@NgModule({
	imports: [RouterModule.forRoot(routes, { onSameUrlNavigation: 'reload' })],
	exports: [RouterModule],
})
export class AppRoutingModule {}
